import type { Lot } from '../data/mockLots';
import { useCountdown, formatStartsIn } from '../hooks/useCountdown';
import { SkinFrame } from './SkinFrame';

export function StartingSoonCard({
  lot,
  index,
  onSelect,
}: { lot: Lot & { startsAt: number }; index: number; onSelect?: () => void }) {
  const startsIn = useCountdown(lot.startsAt);

  return (
    <article
      onClick={onSelect}
      className={`anim-rise relative w-[180px] shrink-0 border border-edge bg-bg-elev/50 ${onSelect ? 'cursor-pointer hover:border-edge-bright transition-colors' : ''}`}
      style={{ animationDelay: `${200 + index * 50}ms` }}
    >
      <div className="relative h-[110px] overflow-hidden border-b border-edge">
        <SkinFrame weapon={lot.weapon} palette={lot.palette} size="sm" />
      </div>

      <div className="p-2.5 flex flex-col gap-1">
        <h4 className="font-display font-semibold text-[12px] leading-tight truncate">
          {lot.weaponLabel}{' '}
          <span style={{ color: lot.palette.accent ?? lot.palette.to }}>| {lot.skinName}</span>
        </h4>

        <div className="flex items-end justify-between mt-1.5">
          <div className="flex flex-col">
            <span className="font-mono text-[9px] text-fg-muted">opens in</span>
            <span
              className={`font-mono font-semibold text-[17px] tabular-nums leading-none mt-0.5 ${
                startsIn <= 30 ? 'text-warning' : 'text-primary'
              }`}
            >
              {formatStartsIn(startsIn)}
            </span>
          </div>
          <span className="font-mono text-[11px] text-fg/85">${lot.marketPrice.toFixed(0)}</span>
        </div>
      </div>
    </article>
  );
}
